import StandardHeaderGameModule, { StandardHeaderGameModuleProps } from '../header/StandardHeaderGameModule';

export function StandardHeaderSellergroupGameModule(props: StandardHeaderSellergroupGameModuleProps) {
    return <StandardHeaderGameModule {...props} />;
}

export type StandardHeaderSellergroupGameModuleProps = StandardHeaderGameModuleProps;

export default StandardHeaderSellergroupGameModule;
